import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommunityReplyRegasyncReqPros, CommunityReplyRegInitialState } from "../model/CommunityReplyRegReducerType";

const reducerId = "CommunityReplyRegReducer/asyncReqCommunityReplyReg";
const controllerMap = new Map();

const initialState: CommunityReplyRegInitialState = {
    status: "",
    n4ErrorCode: 0,
    strErrorMessage: "",
    isSuccess: false,
    INFO: undefined
};

const slice = createSlice({
    name: "CommunityReplyRegReducer",
    initialState,
    reducers: {
        setInitStatus: (state) => {
            state.status = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommunityReplyReg.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommunityReplyReg.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.isSuccess = action.payload.isSuccess;
            state.INFO = action.payload.INFO;
        });
        builder.addCase(asyncReqCommunityReplyReg.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommunityReplyReg = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommunityReplyRegasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ board_seq, ref_comment_seq, nickname, comment, anonymous_yn, file }: CommunityReplyRegasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const formData = new FormData();
            formData.append("board_seq", board_seq);
            formData.append("ref_comment_seq", ref_comment_seq);
            formData.append("nickname", nickname);
            formData.append("comment", comment);
            formData.append("anonymous_yn", anonymous_yn);
            if (file) {
                formData.append("image", file);
            }
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommunityReplyReg.aspx`,
                {
                    method: "POST",
                    body: formData,
                    signal: controller.signal
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommunityReplyRegActions = slice.actions;
export default slice.reducer;